import React, { useState } from 'react'
import { flagMarker } from 'lib/model'
import styles from './flagButton.m.scss'

export const FlagButton = ({
  articleId,
  markerId,
  userId
}: {
  articleId: string
  markerId: string
  userId: string
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false)
  const handleSent = (success: boolean) => {
    setShowConfirmation(success)
  }

  const handleFlag = (markerId: string) => {
    const userId =
      window.localStorage.getItem(articleId + '-userId') || 'not-found'

    if (userId === 'not-found') {
      console.warn('Vote impossible: l’utilisateur n’existe pas')
      return
    }

    flagMarker(markerId, userId, handleSent)
  }

  return (
    <button
      className='ui basic small icon labeled button'
      onClick={() => {
        handleFlag(markerId)
      }}
    >
      {showConfirmation && (
        <div className={`ui label pointing below ${styles.confirmationPopup}`}>
          Merci d’avoir signalé cet emplacement.
        </div>
      )}
      <i className='icon flag' />
      Signaler
    </button>
  )
}
